<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import NftInfo from 'src/components/main/nft/components/nft-info/NftInfo.svelte'
    import MoreNft from 'src/components/main/nft/components/more-nft/MoreNft.svelte'
    import {getNft} from 'src/components/cabinet/#services/inventory'

    export let productId

    let type
    if (productId.includes("lootbox")) {
        type = 'lootbox'
    } else {
        type = 'unit'
    }

    $: productId, reset()

    reset()

    function reset() {
        getNft.reset()
    }
</script>

<MainLayout>
    <svelte:fragment slot="content">
        <NftInfo productId={productId}/>
        <MoreNft productId={productId} type={type}/>
    </svelte:fragment>
</MainLayout>
